<div class="absolute w-full h-full z-10" *ngIf="isVisibleDropdown" (click)="toggleDropdown()"></div>
<div class="bg-white shadow-lg flex items-center justify-between px-6 py-2 z-40 h-14">
    <div class="flex items-center gap-x-6">
        <button (click)="toggleSidebar()">
            <i class="fa-solid fa-bars text-laureate-500 text-lg"></i>
        </button>
        <img [routerLink]="['/explorer']" class="w-32 cursor-pointer" src="/assets/imgs/laureate-logo.png" alt="Laureate">
    </div>
    <div class="flex items-center gap-x-6 cursor-pointer justify-end relative">
        <button class="flex items-center" (click)="toggleDropdown()">
            <p class="hidden md:block mr-4 font-normal">{{ user?.fullName }}</p>
            <shared-avatar-photo [base64]="user?.photo" [name]="user?.fullName"></shared-avatar-photo>
            <i class="fa-solid fa-chevron-down text-laureate-500 ml-4"></i>
        </button>
        <ul *ngIf="isVisibleDropdown" 
            class="absolute z-10 shadow-md bg-white border border-gray-300 top-12">
            <li class="border-b border-gray-300 hover:bg-gray-200 py-2 px-6 text-nowrap" (click)="openBanner()" *ngIf="user?.isAdmin">
                <span>Configuración del sistema</span>
            </li>
            <li class="border-b border-gray-300 hover:bg-gray-200 py-2 px-6 text-nowrap" (click)="redirectToOffice()">
                <span>Mi cuenta office</span>
            </li>
            <li class="border-b border-gray-300 hover:bg-gray-200 py-2 px-6 text-nowrap" (click)="logout()">
                <span>Cerrar sesión</span>
            </li>
        </ul>
    </div>
</div>
